import { BoneTypeEnum, MeasuresController as MeasuresControllerBase, ViewType } from "@ortho-next/nextray-core";
import { AppModel, NextRayMeasures } from "../Models/AppModel";
import { Main } from "./Main";
import { MeasuresCalculator } from "./MeasuresCalculator";

/**
 * Binds measures calculations.
 */
export class MeasuresController extends MeasuresControllerBase {
	public declare measuresCalculator: MeasuresCalculator;
	protected declare _main: Main;
	protected declare _model: AppModel;

	protected override updateMeasureInModel<K extends keyof NextRayMeasures>(...propertiesName: K[]): void {
		super.updateMeasureInModel(...propertiesName as any);
	}

	constructor(main: Main) {
		super(main, MeasuresCalculator);
	}

	public bindEoC(viewType: ViewType): void {
		viewType == ViewType.AP ? this.bindEoCAP() : this.bindEOCLT();
	}

	private bindEoCAP(): void { //todo rendere le stringhe una property dell'oggetto
		const eocPlane = this._main.toolsAP.EoCPlane!;
		const boneType = this._main.caseModel.boneType;

		eocPlane.addEventListener('updated', () => {
			this.updateMeasureInModel(
				"eoc_ap_secondaryTransl",
				"eoc_ap_axialLength",
				"eoc_ap_cortexLength",
				"eoc_ap_angle"
			);
		});

		if (boneType === BoneTypeEnum.LongLeg) {
			eocPlane.addEventListener('updated', () => {
				this.updateMeasureInModel(
					"eoc_ap_MAD",
					"eoc_ap_JLCA",
					"eoc_ap_kneeTranslation",
					"eoc_ap_fullLength"
				);
			});
		}

		if (boneType === BoneTypeEnum.Femur || boneType === BoneTypeEnum.LongLeg) {
			eocPlane.addEventListener('updated', () => {
				this.updateMeasureInModel(
					"eoc_ap_LPFA",
					"eoc_ap_mLDFA",
					"eoc_ap_MNSA",
					"eoc_ap_MPFA",
					"eoc_ap_aLDFA",
					"eoc_ap_femurLength"
				);
			});
		}

		if (boneType === BoneTypeEnum.Tibia || boneType === BoneTypeEnum.LongLeg) {
			eocPlane.addEventListener('updated', () => {
				this.updateMeasureInModel(
					"eoc_ap_MPTA",
					"eoc_ap_LDTA",
					"eoc_ap_tibiaLength"
				);
			});
		}
	}

	private bindEOCLT(): void {
		const eocPlane = this._main.toolsLT.EoCPlane!;

		eocPlane.addEventListener('updated', () => {
			this.updateMeasureInModel(
				"eoc_lt_secondaryTransl",
				"eoc_lt_axialLength",
				"eoc_lt_cortexLength",
				"eoc_lt_angle",
				"eoc_lt_kneeTranslation",
				"eoc_lt_PDFA",
				"eoc_lt_ADTA",
				"eoc_lt_PPTA"
			);
		});
	}
}
